import { IconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const StarIcon: FC<IconProps> = memo(
  ({ size, width, height, fill = '#FADB14', ...props }) => {
    const { rpx } = useResponsiveContext();
    size = size ?? rpx(64);
    return (
      <Svg
        viewBox="0 0 1102 1024"
        width={width ?? size}
        height={height ?? size}
        fill="none"
        {...props}
      >
        <Path
          d="M1038.966154 355.800615l-312.556308-45.371077L586.673231 27.175385a39.542154 39.542154 0 0 0-70.656 0L376.438154 310.429538l-312.477539 45.371077a39.384615 39.384615 0 0 0-21.819077 67.190154l226.067693 220.475077-53.326769 311.217231a39.384615 39.384615 0 0 0 57.107692 41.511385L551.384615 849.132308l279.473231 146.983384a39.384615 39.384615 0 0 0 57.107692-41.511384l-53.405538-311.217231 226.067692-220.475077a39.384615 39.384615 0 0 0-21.740307-67.190154z"
          fill={fill}
        />
      </Svg>
    );
  },
);
